import React from 'react'
import cx from 'classnames'
import style from './heading.module.scss'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'

const VegaHeading = ({ className, tag = 'h1', label }) => {
	return <div className={cx(className, style[tag])}>{label || <Skeleton />}</div>
}

VegaHeading.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Tag HTML of the heading */
	tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7']),
	/** Label of the heading */
	label: PropTypes.string
}

export { VegaHeading }
